import React, { useState } from "react";
import CssTransition from "../../../component/layout/css-transition";
import InputField from "../../../component/input-field";
import Select from "react-select";

function CreateComponentModel({
  modalOpen,
  setModalOpen,
  setShowWatermark,
  componentParameter,
  setComponentParameter,
}) {
  const [selected, setSelected] = useState(0);
  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div className="bg-white overflow-auto max-w-4xl w-full max-h-full rounded-2xl shadow-lg flex flex-col">
          <div className="py-8 px-6 space-y-5">
            <div className="space-y-2">
              <h4 className="text-base leading-5 text-[#1E293B] font-semibold text-center">
                Create New Component
              </h4>
              <div>
                <p className="text-sm text-center text-[#888888] leading-5">
                  Please select a component type
                </p>
                <p className="text-sm text-center text-[#888888] leading-5">
                  to start the configuration.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div
                className={`h-28 rounded-md ${
                  selected === 1 ? "bg-[--bg-color-500]" : "bg-[#F5F9FF]"
                }  px-4 flex justify-center items-center cursor-pointer`}
                onClick={() => {
                  setSelected(1);
                  setComponentParameter({
                    ...componentParameter,
                    componentType: "text",
                  });
                }}
              >
                <InputField
                  type="text"
                  placeholder="This is a Text"
                  label="Text"
                  isReadOnly={true}
                  labelClass={
                    selected === 1
                      ? "text-white leading-3 tracking-tight"
                      : "leading-3 tracking-tight"
                  }
                  suffix={
                    <span className="far fa-calendar text-[#1E293B] invisible"></span>
                  }
                />
              </div>
              <div
                className={`h-28 rounded-md ${
                  selected === 2 ? "bg-[--bg-color-500]" : "bg-[#F5F9FF]"
                }  px-4 flex justify-center items-center cursor-pointer`}
                onClick={() => {
                  setSelected(2);
                  setComponentParameter({
                    ...componentParameter,
                    componentType: "number",
                  });
                }}
              >
                <InputField
                  type="number"
                  placeholder="This is a Number"
                  label="Number"
                  isReadOnly={true}
                  labelClass={
                    selected === 2
                      ? "text-white leading-3 tracking-tight"
                      : "leading-3 tracking-tight"
                  }
                  suffix={
                    <span className="far fa-calendar text-[#1E293B] invisible"></span>
                  }
                />
              </div>
              <div
                className={`h-28 rounded-md ${
                  selected === 3 ? "bg-[--bg-color-500]" : "bg-[#F5F9FF]"
                }  px-4 flex justify-center items-center cursor-pointer`}
                onClick={() => {
                  setSelected(3);
                  setComponentParameter({
                    ...componentParameter,
                    componentType: "date/time",
                  });
                }}
              >
                <InputField
                  type="text"
                  placeholder="This is a Date / Time"
                  label="Date/Time"
                  isReadOnly={true}
                  labelClass={
                    selected === 3
                      ? "text-white leading-3 tracking-tight"
                      : "leading-3 tracking-tight"
                  }
                  suffix={
                    <span className="far fa-calendar text-[#1E293B]"></span>
                  }
                />
              </div>
              <div
                className={`h-28 rounded-md ${
                  selected === 4 ? "bg-[--bg-color-500]" : "bg-[#F5F9FF]"
                }  px-4 flex justify-center items-center cursor-pointer`}
                onClick={() => {
                  setSelected(4);
                  setComponentParameter({
                    ...componentParameter,
                    componentType: "dropdown",
                  });
                }}
              >
                <div className="flex-1 cursor-pointer">
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      selected === 4
                        ? "text-white leading-3 tracking-tight"
                        : "leading-3 tracking-tight"
                    }`}
                    htmlFor="card-city"
                  >
                    Dropdown
                  </label>
                  <Select
                    className="basic-single text-sm unresetText"
                    isDisabled
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: "white", // Set a custom background color
                        borderColor: "lightgray", // Set a custom border color
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                      placeholder: (provided, state) => ({
                        ...provided,
                        color: "#9297A2", // Set your desired color here
                        fontSize: "14px",
                      }),
                    }}
                    classNames={{
                      control: (style) => {
                        return `!border !shadow-sm ${
                          style.isFocused
                            ? "!border-[--bg-color-300]/50"
                            : "!border-slate-200 hover:!border-gray-300"
                        }`;
                      },
                      container: (style) => {
                        return "!h-[37.5px] !font-inter !text-sm";
                      },
                      menuList: (style) => {
                        return `!max-h-[200px]`;
                      },
                    }}
                    classNamePrefix="select"
                    placeholder="This is a Dropdown"
                  />
                </div>
              </div>
              <div
                className={`h-28 rounded-md ${
                  selected === 5 ? "bg-[--bg-color-500]" : "bg-[#F5F9FF]"
                }  px-4 flex justify-start items-center cursor-pointer`}
                onClick={() => {
                  setSelected(5);
                  setComponentParameter({
                    ...componentParameter,
                    componentType: "check box",
                  });
                }}
              >
                <div className="space-y-1">
                  <h6
                    className={`block text-sm font-medium ${
                      selected === 5
                        ? "text-white leading-3 tracking-tight"
                        : "leading-3 tracking-tight"
                    }`}
                  >
                    Check Box
                  </h6>
                  <div className="flex items-center h-[34px]">
                    <input type="checkbox" className="form-checkbox" disabled />
                    <span
                      className={`text-sm ml-2 ${
                        selected === 5 ? "text-white" : "text-[#535860]"
                      } tracking-tight leading-3 font-light`}
                    >
                      This is a Check Box
                    </span>
                  </div>
                </div>
              </div>
              <div
                className={`h-28 rounded-md ${
                  selected === 6 ? "bg-[--bg-color-500]" : "bg-[#F5F9FF]"
                }  px-4 flex justify-center items-center cursor-pointer`}
                onClick={() => {
                  setSelected(6);

                  setComponentParameter({
                    ...componentParameter,
                    componentType: "paragraph",
                  });
                }}
              >
                <div className="flex-1 cursor-pointer space-y-1">
                  <label
                    className={`block text-sm font-medium ${
                      selected === 6 ? "text-white" : "text-[#535860]"
                    }`}
                  >
                    Paragraph
                  </label>
                  <textarea
                    rows="2"
                    className="w-full form-textarea resize-none"
                    placeholder="This is a Paragraph"
                    readOnly
                  ></textarea>
                </div>
              </div>
              <div
                className={`h-28 rounded-md ${
                  selected === 7 ? "bg-[--bg-color-500]" : "bg-[#F5F9FF]"
                }  px-4 flex justify-center items-center cursor-pointer`}
                onClick={() => {
                  setSelected(7);
                  console.log({componentParameter});
                  setComponentParameter({
                    ...componentParameter,
                    componentType: "link",
                  });
                }}
              >
                <div className="flex-1 cursor-pointer space-y-1">
                  <label
                    className={`block text-sm font-medium ${
                      selected === 7 ? "text-white" : "text-[#535860]"
                    }`}
                  >
                    Link
                  </label>
                  <div className="bg-white h-9 rounded flex justify-between items-center px-2">
                    <h6 className="text-[13px] leading-5 tracking-tight font-semibold text-[--bg-color-500]">
                      Go to Link
                    </h6>
                    <span className="fas fa-link text-[--bg-color-500] text-[13px]"></span>
                  </div>
                </div>
              </div>
              <div
                className={`h-28 rounded-md ${
                  selected === 8 ? "bg-[--bg-color-500]" : "bg-[#F5F9FF]"
                }  px-4 flex justify-center items-center cursor-pointer`}
                onClick={() => {
                  setSelected(8);
                  setComponentParameter({
                    ...componentParameter,
                    componentType: "radio group",
                  });
                }}
              >
                <div className="flex-1 cursor-pointer space-y-0">
                  <h6
                    className={`block text-sm font-medium ${
                      selected === 8 ? "text-white" : "text-[#535860]"
                    }`}
                  >
                    Radio Group
                  </h6>
                  <div>
                    <div className="space-x-3">
                      <input
                        type="radio"
                        id="option1"
                        name="fav_language"
                        className="h-4 w-4 border-gray-300 form-radio"
                        checked={true}
                        disabled
                      />
                      <label
                        htmlFor="option1"
                        className={`text-sm leading-4 tracking-tight font-medium cursor-pointer ${
                          selected === 8 ? "text-white" : "text-[#535860]"
                        }`}
                      >
                        This is a Radio Item
                      </label>
                    </div>
                    <div className="space-x-3">
                      <input
                        type="radio"
                        id="option2"
                        name="fav_language"
                        className="h-4 w-4 border-gray-300 form-radio"
                        disabled
                      />
                      <label
                        htmlFor="option2"
                        className={`text-sm leading-4 tracking-tight font-medium cursor-pointer ${
                          selected === 8 ? "text-white" : "text-[#535860]"
                        }`}
                      >
                        This is another Radio Item
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`h-28 rounded-md ${
                  selected === 9 ? "bg-[--bg-color-500]" : "bg-[#F5F9FF]"
                }  px-4 flex justify-center items-center cursor-pointer`}
                onClick={() => {
                  setSelected(9);
                  setComponentParameter({
                    ...componentParameter,
                    componentType: "toggle",
                  });
                }}
              >
                <div className="flex-1 cursor-pointer space-y-4">
                  <h6
                    className={`block text-sm font-medium ${
                      selected === 9 ? "text-white" : "text-[#535860]"
                    }`}
                  >
                    Toggle
                  </h6>
                  <div className="flex items-center space-x-3">
                    <div className="form-switch">
                      <input
                        type="checkbox"
                        name="Advance Control Setting"
                        checked={false}
                        className="sr-only"
                        // disabled
                      />
                      <label htmlFor="controlSetting" className="bg-slate-400">
                        <span
                          className="bg-white shadow-sm"
                          aria-hidden="true"
                        ></span>
                      </label>
                    </div>
                    <h6
                      className={`text-[13px] ${
                        selected === 9 ? "text-white" : "text-[#535860]"
                      } tracking-tight leading-3`}
                    >
                      This is a Toggle
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center space-x-4">
              <button
                className="md:w-52 btn bg-white border-slate-200 hover:border-slate-300 text-[#1E293B] text-sm font-semibold leading-5 cursor-pointer"
                onClick={() => {
                  setSelected(0)
                  setModalOpen(false);
                  setComponentParameter({
                    ...componentParameter,
                    componentType: "",
                  });
                  setShowWatermark(true);
                }}
              >
                Cancel
              </button>
              <button
                className="md:w-52 btn bg-[--bg-color-500] hover:bg-[--bg-color-700] text-white text-sm font-semibold leading-5"
                onClick={() => {
                  setModalOpen(false);
                  setShowWatermark(false);
                  setSelected(0)
                }}
              >
                Create
              </button>
            </div>
          </div>
        </div>
      </CssTransition>
    </>
  );
}

export default CreateComponentModel;
